import React, { useEffect } from 'react'
import { TypeExpertise } from '../../../enums/TypeExpertise'
import { Activite } from '../../../enums/Activite'
import { Site } from '../../../types/Site'
import { useInspections } from '../hooks'
import UnsavedChangesAlert from './UnsavedChangesAlert'

declare const window: any

export default function Inspections() {
    const { sites, hasChanges, submitting, toggleExpertise, isInspectionActive, save } = useInspections()

    const [activeTab, setActiveTab] = React.useState<'automobile' | 'moto' | 'vdl'>('automobile')

    useEffect(() => { window.$('[data-toggle="tooltip"]').tooltip() })

    const filteredSites = sites.filter((site: Site) => {
        const activityId = site.Plaque_IDActivite ?? site.IDActivite
        if (activeTab === 'automobile') return activityId === Activite.Automobile
        if (activeTab === 'moto') return activityId === Activite.Moto
        if (activeTab === 'vdl') return activityId === Activite.Loisirs
    })

    const expertiseTypes = Object.values(TypeExpertise).filter((v): v is TypeExpertise => typeof v === 'number')

    return (
        <>
            <div className="container-fluid mb-2">
                <div className="row">f
                    <div className="col">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <span className="text-muted">Vous pouvez configurer par site et par activité, les catalogues à utiliser pour la gestion des expertises</span>
                            <div>
                                {hasChanges && <UnsavedChangesAlert hasChanges={hasChanges} submitting={submitting} onSubmit={save} />}
                            </div>
                        </div>
                        <ul className="nav nav-tabs" id="myTab">
                            <li className="nav-item">
                                <a onClick={() => setActiveTab('automobile')} className="nav-link active" id="automobile-tab" data-toggle="tab" href="#automobile" role="tab" aria-controls="automobile" aria-selected="true">Automobile</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => setActiveTab('moto')} className="nav-link" id="moto-tab" data-toggle="tab" href="#moto" role="tab" aria-controls="moto" aria-selected="true">Moto</a>
                            </li>
                            <li className="nav-item">
                                <a onClick={() => setActiveTab('vdl')} className="nav-link" id="vdl-tab" data-toggle="tab" href="#vdl" role="tab" aria-controls="vdl" aria-selected="true">VDL</a>
                            </li>
                        </ul>
                        <div className="tab-content" id="myTabContent" style={{ paddingTop: '15px' }}>
                            <div className="tab-pane fade show active" id="automobile" role="tabpanel" aria-labelledby="automobile-tab"></div>
                            <div className="tab-pane fade" id="moto" role="tabpanel" aria-labelledby="moto-tab"></div>
                            <div className="tab-pane fade" id="vdl" role="tabpanel" aria-labelledby="vdl-tab"></div>
                        </div>
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th scope="col">Société</th>
                                    <th scope="col">Site</th>
                                    {expertiseTypes.map(type => (
                                        <th key={type}>{TypeExpertise[type]}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {filteredSites.map((site: any) => (
                                    <tr key={site.IDSite}>
                                        <td>{site.Plaque_Libelle}</td>
                                        <td>{site.Descr}</td>
                                        {expertiseTypes.map(type => (
                                            <td key={type} className="text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={isInspectionActive(site.IDSite, type)}
                                                    onChange={(e) => toggleExpertise(site.IDSite, type, e.target.checked)}
                                                />
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <div className="row mt-4">
                            <div className="col text-center">
                                <button
                                    disabled={!hasChanges}
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={save}
                                >
                                    {submitting && <i className="fa fa-spinner fa-spin fa-fw mr-1"></i>}
                                    Valider
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
